import { Controller } from "@hotwired/stimulus"
import { highchartsSetupV12 } from "@xlayer/composables/chartModules/highchartsSetup"
import Highcharts from "highcharts-v12"

export default class extends Controller {
  static targets = ["content", "warn"]
  
  static values = {
    basecheckData: String
  }

  connect() {
    highchartsSetupV12()
    const data = JSON.parse(this.basecheckDataValue)
    this.initializeChart(data)
    
    if (data.warn) {
      const button = this.element.querySelector('#basecheck-button')
      button.classList.add('warning')
      const icon = this.element.querySelector('#basecheck-icon')
      icon.classList.add('text-red-500')
      this.warnTarget.classList.remove('hidden')
      this.warnTarget.textContent = 
        "Die Stichproben für die rot markierten Erhebungszeiträume sind zu klein. Bitte wähle eine alternative Filterauswahl, um valide Ergebnisse zu generieren."
    }
  }

  initializeChart(data) {
    const chartContainer = document.createElement('div')
    this.contentTarget.appendChild(chartContainer)
    Highcharts.chart(chartContainer, data.highchartsData)
  }

  show() {
    this.contentTarget.classList.remove("hidden")
  }

  hide() {
    this.contentTarget.classList.add("hidden")
  }
} 
